import { Box, IconButton, Typography } from '@mui/material';
import { ColumnDef } from '@tanstack/react-table';
import { useGetPrompts } from 'apis/agency/prompt/hook';
import { PromptResponse } from 'apis/agency/prompt/types';
import DataTable from 'components/Common/DataTable';
import Pagination from 'components/Common/Pagination';
import { useState } from 'react';
import { MdOutlineEdit } from 'react-icons/md';
import { Link, Outlet } from 'react-router-dom';

export default function Prompts() {
  const [currentPage, setCurrentPage] = useState(1);

  const { data: prompt, isLoading: isAgentTemplateLoading } = useGetPrompts(currentPage);

  return (
    <>
      <Typography variant='h2' fontWeight={500} mb={2}>
        Prompts
      </Typography>

      <DataTable data={prompt?.data} columns={columns()} isHeaderSticky={true} isLoading={isAgentTemplateLoading} />
      <Pagination totalPages={prompt?.meta?.total_pages} currentPage={currentPage} onChange={setCurrentPage} />
      <Outlet />
    </>
  );
}

const columns = (): ColumnDef<PromptResponse>[] => [
  {
    header: 'Name',
    accessorKey: 'name',
    cell: (info) => (info.getValue() as string).replace(/_/g, ' ')
  },
  {
    header: 'Prompt Type',
    accessorKey: 'prompt_type'
  },
  {
    header: 'Action',
    cell: (info) => (
      <Box display='flex' gap={1}>
        <Link to={String(info.row.original.id)}>
          <IconButton>
            <MdOutlineEdit />
          </IconButton>
        </Link>
      </Box>
    )
  }
];
